import * as actionTypes from "./constants";

const fetchLoadData = (params) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.FETCH_LOAD_INIT_ACTION,
      params: params,
    });
  };
};

const fetchTripDesignLoadDataid = (value) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.FETCH_LOAD_ID_INIT_ACTION,
      value: value,
    });
  };
};

const setTabKeyAction = (value) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.TAB_KEY_INIT_ACTION,
      value: value,
    });
  };
};

const fetchSubscriptnLog = (value) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.FETCH_SUBLOG_INIT_ACTION,
      value: value,
    });
  };
};

// const fetchVehicleData = (params) => {
//   return (dispatch) => {
//     dispatch({
//       type: actionTypes.FETCH_LOAD_VEHICLE_INIT_ACTION,
//       params: params,
//     });
//   };
// };
// const fetchDriverData = (params) => {
//   return (dispatch) => {
//     dispatch({
//       type: actionTypes.FETCH_LOAD_DRIVER_INIT_ACTION,
//       params: params,
//     });
//   };
// };

const rejectLoad = (value) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.REJECT_LOAD_INIT,
      value: value,
    });
  };
};

const getPaymentMode = () => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.GET_PAYMODE_INIT,
    });
  };
};

export default {
  fetchLoadData,
  fetchTripDesignLoadDataid,
  setTabKeyAction,
  fetchSubscriptnLog,
  rejectLoad,
  getPaymentMode
  // fetchVehicleData,
  // fetchDriverData,
};
